import { useForm } from "react-hook-form";
import { useLocation, useParams } from "react-router-dom";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import api from "../../../../api/api";
import BackButton from "../../../../components/common/backbutton/BackButton";
import FormBranch from "../../../../components/common/forms/FormBranch";
import FormButtom from "../../../../components/common/forms/FormButtom";
import FormPayment from "../../../../components/common/forms/FormPayment";
import NewFormPayment from "../../../../components/common/forms/NewFormPayment";


const CalenderPrinting = () => {
  const { register, handleSubmit } = useForm();



  const onSubmit = (data) => {
    // console.log(data);
    // console.log(state);

    const user = JSON.parse(localStorage.getItem("user"));

    data.user = user.user_id
    data.type = "calp"

    api.post('/design-and-printing/', data)
      .then(response => {
        console.log(response.data)
      }).catch(error => {
        console.log(error)
      })

  };

  // alert("hello world")
  return (
    <>
      <div>
        <div className="">
          <form className="px-10 lg:!px-14">
            <h1 className="text-primary-red font-Rakkas mt-7 text-center text-xl font-semibold tracking-wide underline md:!text-3xl">
              {/* {slug.split("-")[0]} */}
              Calander Printings
            </h1>
            {/* company name details */}
            <div className="mt-5">


              <div className="flex justify-between">
                <p className=" text-lg ">
                  क्यालेन्डर छपाईको लागि निम्नुसारको विवरण भरेर अर्डर गर्नुहोस ।
                </p>
                <p className="text-primary-red flex">
                  Firm No.
                  <p className=" text-primary-blue"> 1234</p>
                </p>
              </div>


              <div className="mt-4">
                <div className="flex-col flex md:flex-row flex-wrap">
                  <div className="flex flex-1 flex-wrap  border items-center m-0 px-2 border-primary-blue">
                    <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
                      क्यालेन्डर छाप्ने कम्पनी वा ब्यवसायको नाम :
                    </label>
                    <input
                      type="text"
                      placeholder="e.g भरतपुर ट्रेदिङ् प्रा.ली."
                      {...register("business_name", { required: false, })}
                      // name="company_name"
                      className=" text-primary-blue w-[60%] m-0  py-3 px-3 outline-none"
                    />
                  </div>
                  <div className="flex flex-1 flex-wrap w-fit  border md:border-l-0 px-2 items-center border-primary-blue">
                    <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
                      कम्पनीको ठेगाना :
                    </label>
                    <input
                      type="text"
                      placeholder="e.g भरतपुर - ११ , चितवन"
                      name="address"
                      {...register("business_address", { required: false, })}
                      className=" text-primary-blue w-[60%] flex-shrink-0 m-0  py-3 px-3 outline-none"
                    />
                  </div>
                </div>
                <div className="flex-col flex md:flex-row">
                  <div className="flex flex-1 flex-wrap border items-center border-t-0 px-2 border-primary-blue">
                    <label className="border-primary-blue  flex-shrink-0 text-primary-red  text-lg font-bold">
                      दर्ता नं. :{" "}
                    </label>
                    <input
                      type="number"
                      placeholder="e.g ६०७६/५३४४३/३५"
                      {...register("reg_number", { required: false, })}
                      className=" text-primary-blue w-[30%]  m-0  py-3 px-2 outline-none"
                    />
                  </div>
                  <div className="flex flex-1  border border-l-0 px-2 items-center border-t-0 border-primary-blue">
                    <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
                      पान नं. :
                    </label>
                    <input
                      type="number"
                      placeholder="e.g १२३४५६६६५५"
                      {...register("pan_number", { required: false, })}

                      className=" text-primary-blue w-[80%] m-0  py-3 px-3 outline-none"
                    />
                  </div>
                  <div className="flex flex-1 flex-wrap  border border-l-0 px-2 items-center border-t-0 border-primary-blue">
                    <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
                      छपाई गर्दा राख्ने सम्पर्क नं. :
                    </label>
                    <input
                      type="number"
                      placeholder="e.g ९८००००००००"
                      // name="phone_nummber"
                      className=" text-primary-blue  m-0 px-3  outline-none"
                      {...register("contact_number", { required: false, })}

                    />
                  </div>
                </div>
              </div>

              <div className="flex-col flex mt-5 md:flex-row">
                <div className="flex flex-1 flex-wrap border items-center  px-2 border-primary-blue">
                  <label className="border-primary-blue  flex-shrink-0 text-primary-red  text-lg font-bold">
                    छपाई गर्ने साईज :
                  </label>
                  <input
                    type="number"
                    placeholder="e.g १५*२०"

                    {...register("printing_size", { required: false, })}
                    // name="calander_size"
                    className=" text-primary-blue w-[50%]  m-0  py-3 px-3 outline-none"
                  />
                </div>
                <div className="flex flex-1 flex-wrap  border border-l-0 px-2 items-center  border-primary-blue">
                  <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
                    पाना :
                  </label>
                  <input
                    type="number"
                    placeholder="e.g १२"
                    // name="paper_quatity"
                    {...register("pan_number", { required: false, })}
                    className=" text-primary-blue w-[50%] px-3   outline-none"
                  />
                </div>
                <div className="flex flex-1  border border-l-0 px-2 items-center  border-primary-blue">
                  <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
                    छपाई परिमाण :
                  </label>
                  <input
                    type="number"
                    placeholder="Type Here ............"
                    name="calander_quantity"
                    {...register("quantity", { required: false, })}
                    className=" text-primary-blue w-[50%] m-0  py-3 px-3 outline-none"
                  />
                </div>
                <div className="flex flex-1 flex-wrap  border border-l-0 px-2 items-center  border-primary-blue">
                  <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
                    लाग्ने जम्मा रकम :
                  </label>
                  <input
                    type="text"
                    placeholder="Type Here ............"
                    name="total_cost"
                    {...register("amount", { required: false, })}
                    className=" text-primary-blue w-[50%]  px-3 outline-none"
                  />
                </div>
              </div>


              <div className="border-2  rounded-[2rem] align-middle border-red-600 mt-3">
                <p className="text-primary-blue mt-0 text-base font-medium leading-10 md:!text-lg text-center">
                  Service Fees Shown above are not inlcude any Goverment
                  Charges,VAT,Taxes,Fines,Penalties and Incidental costs
             0   </p>
              </div>
            </div>

            {/* company objective */}
            <div className="mt-5">
              <p className="text-primary-blue  font-bold">

                अन्य केहि बिवरण दिनु पर्ने भएका यहाँ लेख्नुहोस् ।

              </p>
              {/* text area */}
              <div className="mt-3">
                <textarea
                  // name=""
                  className="border-primary-blue w-full border p-3"
                  id=""
                  cols={30}
                  rows={10}
                  defaultValue={""}
                  // remarks
                  {...register("remarks", { required: false, })}
                />
              </div>
            </div>
            {/* branch */}


            <FormBranch register={register} name="working_branch_code" />



            <div className="mt-10 grid place-content-center">
            </div>
<FormButtom/>
            {/* sumbit modal */}
            
            <NewFormPayment
              handleSubmit={handleSubmit}
              handleClick={onSubmit}
            />
          </form>
        </div>
      </div>
    </>
  );
};
export default CalenderPrinting;
